// extracted by css-extract-rspack-plugin
export default {"SavedEntityPickerRoot":"G0aMK","CollectionsContainer":"QKaZX","BackButton":"gemzn"};